/**
 * Liberty Mutual Bonds authentication handler
 */

export interface LibertyMutualBondsCredentials {
    customerId: string;
    accessCode: string;
}

/**
 * Authenticates and redirects to Liberty Mutual Bonds
 * Uses form submission to avoid CORS issues
 * @param apiUrl The Liberty Mutual Bonds API URL from backend appsettings
 * @param credentials Liberty Mutual Bonds credentials (customerId and accessCode)
 */
export const authenticateLibertyMutualBonds = (apiUrl: string, credentials: LibertyMutualBondsCredentials): void => {
    const { customerId, accessCode } = credentials;
    // Create a form element
    const form = document.createElement("form");
    form.method = "POST";
    form.action = apiUrl;
    form.target = "_self"; // Open in same tab
    form.style.display = "none";

    // Add form fields
    const customerIdInput = document.createElement("input");
    customerIdInput.type = "hidden";
    customerIdInput.name = "customerId";
    customerIdInput.value = customerId;
    form.appendChild(customerIdInput);

    const accessCodeInput = document.createElement("input");
    accessCodeInput.type = "hidden";
    accessCodeInput.name = "accessCode";
    accessCodeInput.value = accessCode;
    form.appendChild(accessCodeInput);

    
    // Append form to body and submit
    document.body.appendChild(form);
    form.submit();

    // Clean up
    setTimeout(() => {
        document.body.removeChild(form);
    }, 1000);
};
